<div fxLayout="row" *ngIf="baseLayers.length > 1">
    <form [formGroup]="blForm" fxFlexFill>
  <mat-form-field fxFlexFill>
    <mat-label>{{ 'baselayer-dropdown.baselayers' | translate }}</mat-label>
    <mat-select
    id="baselayers"
    matInput
    [formControlName]="'bl'"
    >
    <mat-option *ngFor="let bl of baseLayers" [value]="bl.title" (onSelectionChange)="listenerBaseLayerSelect(bl, $event)">{{bl.title}}</mat-option>
    </mat-select>
  </mat-form-field>
  </form>
</div>